import React from 'react'
import { useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/Dailylogs': return 'Daily Revenue';
      case '/mis-data': return 'MIS Report';
      case '/one_hour': return 'Hourly Logs';
      case '/userLogs': return 'User Logs';
      case '/black-list': return 'BlackList User';
      case '/unsub': return 'Unsubscribe User';
      case '/hourly-trend': return 'Hourly Trend';
      case '/traffic-data': return 'Traffic Data';
      default: return 'Dashboard';
    }
  }

  return (
    <nav className='sticky top-0 z-20 hidden lg:flex bg-white/70 backdrop-blur-xl border-b border-slate-200/60 transition-all duration-300'>
      <div className='w-full px-8 py-4 flex items-center justify-between'>
        
        <div className="flex items-center gap-3">
          <h2 className="text-xl font-bold text-slate-800">{getPageTitle()}</h2>
        </div>

        <div className='flex items-center gap-4'>
          <div className='text-right px-4 py-2 bg-white rounded-full border border-slate-200 shadow-sm'>
            <p className='text-[10px] uppercase tracking-[0.25em] text-slate-400 font-bold leading-none mb-1'>Welcome Back</p>
            <p className='text-sm font-bold text-slate-800 leading-none'>Admin User</p>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
